import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";
import { SubDepartment } from "../../utility/modals";

@Injectable({ providedIn: 'root' })
export class SubdepartmentService {
  constructor(private httpClient: HttpClient, private route: Router) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + '/common/subdepartment';
  getConfiguration(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/getconfiguration`);
  }
  get_department(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/departmentdata`);
  }
  postsubdepartment(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/createSubdepartment`, payload);  // audit Add
  }
  modifysubdepartment(payload: any): Observable<any> {
    return this.httpClient.put(`${this.baseURL}/updatesubdepartment`, payload);
  }
  getall_subdepartment(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/subdepartmentdata`);
  }
  getSubdepartmentDataView_byId(subdepartmentid: number): Observable<SubDepartment> {
    return this.httpClient.get<SubDepartment>(`${this.baseURL}/findsubdepartment/${subdepartmentid}`);
  }
  subdepartmentDataExcel() {
    return this.httpClient.get(`${this.baseURL}/subdepartmentDataExcel`, { responseType: 'blob' });
  }

} 